module.exports = __webpack_public_path__ + "img/l3.820136fa.png";